<script>
  import { currMenu, systemLog } from "../editor/storage.js";
  export let clickFunction;
  export let kbFunction;
  export let preventKeyboardAction = false;
  import { openSystemTooltip, closeSystemTooltip } from "../editor/utility.js";
  import ExplorationMenuButton from "./menu/explorationMenuButton.svelte";
</script>

<!-- keyboard shortcut listener -->
<svelte:body
  on:keypress={(event) => {
    if (!preventKeyboardAction) {
      if (event.key == "a") kbFunction(event, "artboard");
      else if (event.key == "d") kbFunction(event, "data");
      else if (event.key == "f") kbFunction(event, "data_transformation");
      else if (event.key == "l") kbFunction(event, "layout");
      else if (event.key == "p") kbFunction(event, "projection");
      else if (event.key == "v") kbFunction(event, "selection");
      else if (event.key == "m") kbFunction(event, "mark");
      else if (event.key == "x") kbFunction(event, "axis");
      else if (event.key == "g") kbFunction(event, "legend");
      // else if (event.key == "r") kbFunction(event, "reference");
      else if (event.key == "t") kbFunction(event, "title");
      else if (event.key == "n") kbFunction(event, "annotation");
      // else if (event.key == "e") kbFunction(event, "emphasis");
      else if (event.key == "i") kbFunction(event, "interaction");
      $systemLog.log({ message: "Used a shortcut", key: event.key });
    }
  }}
/>

<!-- Data/Artboard -->
<div id="dupo-first-menu">
  <section class="first-menu-section b">
    <button
      class={"icon-menu" + ($currMenu === "artboard" ? " selected" : "")}
      type="button"
      aria-roledescription="Manage artboard (a)"
      on:click={(event) => clickFunction(event, "artboard")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-easel-fill" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "data" ? " selected" : "")}
      type="button"
      aria-roledescription="Manage data (d)"
      on:click={(event) => clickFunction(event, "data")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-table" />
    </button>
    <button
      class={"icon-menu" +
        ($currMenu === "data_transformation" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit Data Transformation (f)"
      on:click={(event) => clickFunction(event, "data_transformation")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-funnel-fill" />
    </button>
  </section>

  <!-- Layout -->
  <section class="first-menu-section b">
    <button
      class={"icon-menu" + ($currMenu === "layout" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit Layout (l)"
      on:click={(event) => clickFunction(event, "layout")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-grid-fill" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "projection" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit Projection (p)"
      on:click={(event) => clickFunction(event, "projection")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-map-fill" />
    </button>
  </section>

  <!-- Else -->
  <section class="first-menu-section b">
    <button
      class={"icon-menu" + ($currMenu === "selection" ? " selected" : "")}
      type="button"
      aria-roledescription="Make Selection (v)"
      on:click={(event) => clickFunction(event, "selection")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-cursor-fill" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "mark" ? " selected" : "")}
      type="button"
      aria-roledescription="Manage mark layers & encodings (m)"
      on:click={(event) => clickFunction(event, "mark")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-circle-square" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "axis" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit Axes (x)"
      on:click={(event) => clickFunction(event, "axis")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-rulers" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "legend" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit Legends (g)"
      on:click={(event) => clickFunction(event, "legend")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-moisture" />
    </button>
    <!-- <button
      class={"icon-menu" + ($currMenu=== "reference" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit axes, legends, and labels (r)"
      on:click={(event) => clickFunction(event, "reference")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-moisture" />
    </button> -->
    <button
      class={"icon-menu" + ($currMenu === "title" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit Titles (t)"
      on:click={(event) => clickFunction(event, "title")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-card-heading" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "annotation" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit Annotations (n)"
      on:click={(event) => clickFunction(event, "annotation")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-tags" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "interaction" ? " selected" : "")}
      type="button"
      aria-roledescription="Edit Interaction (i)"
      on:click={(event) => clickFunction(event, "interaction")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-joystick" />
    </button>
  </section>

  <section class="first-menu-section">
    <ExplorationMenuButton {clickFunction} />
  </section>
</div>
